export const PAUSE_BROADCAST_ACTIONS = {
  PAUSE: 'PAUSE',
  RESUME: 'RESUME',
};
